module.exports = __webpack_public_path__ + "yz/img/申通.dc3dbdd3.jpg";